/* eslint-disable import/no-anonymous-default-export */
import { getRoutingUrl } from '@mercadoni/sinister/dist/cjs/client/utils'

export default ({ slug = null, redirectTo = null, reference = null }) =>
  getRoutingUrl(`/ca/${redirectTo || slug || reference}`)
